export enum PLACEMENT_SURFACE_TYPE {
    FLOOR = 'Floor',
    WALL = 'Wall',
    CEILING = 'Ceiling',
}
